/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RoleStateOfUse = {
    Enabled: 'Enabled'
} as const;
export type RoleStateOfUse = typeof RoleStateOfUse[keyof typeof RoleStateOfUse];


export function RoleStateOfUseFromJSON(json: any): RoleStateOfUse {
    return RoleStateOfUseFromJSONTyped(json, false);
}

export function RoleStateOfUseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleStateOfUse {
    return json as RoleStateOfUse;
}

export function RoleStateOfUseToJSON(value?: RoleStateOfUse | null): any {
    return value as any;
}

/**
 * Check if a given object implements the RoleStateOfUse interface.
 */
 export function instanceOfRoleStateOfUse(value: any): value is RoleStateOfUse {
    return Object.values(RoleStateOfUse).includes(value)
}

